import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';
 
@Component({
  selector: 'app-action-buttons',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div
      class="surface-card rounded-3xl p-5 md:p-6 space-y-3 antialiased"
    >
      <button
        (click)="onRequestCall()"
        class="btn-primary group w-full flex items-center justify-center gap-2.5 px-5 py-3.5 text-white text-xs font-black uppercase tracking-wider font-mono rounded-xl shadow-glow transition-all duration-200"
      >
        <i class="fa-solid fa-phone text-[11px] text-white group-hover:animate-wiggle"></i>
        <span>{{ 'projectsDetails.requestCall' | translate }}</span>
      </button>

      <button
        (click)="onBookVisit()"
        class="w-full flex items-center justify-center gap-2.5 px-5 py-3.5 bg-surface-elevated hover:bg-surface-hover border border-border-strong hover:border-border-primary text-text-primary text-xs font-black uppercase tracking-wider font-mono rounded-xl active:scale-[0.99] transition-all duration-150"
      >
        <i class="fa-solid fa-calendar-days text-[11px] text-primary"></i>
        <span>{{ 'projectsDetails.bookVisit' | translate }}</span>
      </button>

      <button
        (click)="onGetBrochure()"
        class="group w-full flex items-center justify-center gap-2.5 px-5 py-3.5 bg-surface hover:bg-surface-hover text-text-secondary hover:text-text-primary text-xs font-bold font-mono rounded-xl border border-border transition-all duration-150"
      >
        <i
          class="fa-solid fa-file-pdf text-[11px] text-text-muted group-hover:text-primary group-hover:translate-y-0.5 transition-all"
        ></i>
        <span>{{ 'projectsDetails.getBrochure' | translate }}</span>
      </button>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      @keyframes wiggle {
        0%,
        100% {
          transform: rotate(0deg);
        }
        25% {
          transform: rotate(-8deg);
        }
        75% {
          transform: rotate(8deg);
        }
      }
      .group:hover .animate-wiggle {
        animation: wiggle 0.3s ease-in-out infinite;
      }
    `,
  ],
})
export class ActionButtonsComponent {
  @Output() requestCall = new EventEmitter<void>();
  @Output() bookVisit = new EventEmitter<void>();
  @Output() getBrochure = new EventEmitter<void>();

  onRequestCall() {
    this.requestCall.emit();
  }

  onBookVisit() {
    this.bookVisit.emit();
  }

  onGetBrochure() {
    this.getBrochure.emit();
  }
}
